angular.module('impactx.basket').directive('appBasketItemBulkChangeControls', function ()
{
    return {
        scope: {
            data: "=",
            trns: '=',
            helperDialogParams: "="
        },
        restrict: 'E',
        templateUrl: 'modules/basket/templates/basket-item-bulk-change-dialog-controls.html',
        controller: function($scope) {
            $scope.toogleChangeAAT = function () {
                if (!$scope.data.changeAAT) {
                    $scope.data.aat.selected.id = 0;
                    $scope.changeAAT(0);
                }
            };

            $scope.changeAAT = function (selectedAATId) {
                var tempScope = {};
                dataGen.getData(tempScope, {aatId: selectedAATId, bksId: 0, bkiId: 0}, '/basket/input/controlstructure').then(function () {
                    $scope.data.aat = tempScope.data.aat;
                    $scope.data.control = tempScope.data.control;
                });
            };
        }
    };
});